const service = (() => {
  const getApiTimeoutMilliSeconds = () => window.APP_ENV.API_TIMEOUT_MILLISECONDS;

  const getApiBaseUrl = () => window.APP_ENV.API_BASE_URL;
  
  const getApiBaseProductUrl = () => window.APP_ENV.API_BASE_PRODUCT_URL;

  const getAppBaseUrl = () => window.APP_ENV.APP_BASE_URL.substr(0, window.APP_ENV.APP_BASE_URL.lastIndexOf("/") + 1);

  const getApiEndpointProduct = () => window.APP_ENV.API_ENDPOINT_PRODUCT;

  const getApiEndpointCostToTrade = () => window.APP_ENV.API_ENDPOINT_COST_TO_TRADE;

  const getApiEndpointSpread = () => window.APP_ENV.API_ENDPOINT_SPREAD;

  const getApiEndpointBidAskQuantity = () => window.APP_ENV.API_ENDPOINT_BID_ASK_QUANTITY;

  const getApiEndpointFeedback = () => window.APP_ENV.API_ENDPOINT_FEEDBACK;

  const getApiEndpointHelp = () => window.APP_ENV.API_ENDPOINT_HELP;

  const getApiEndpointHelpImages = () => window.APP_ENV.API_ENDPOINT_HELP_IMAGES;

  const areMultipleLotSizesAllowedForOverlayComparison = () => window.APP_ENV.ALLOW_MULTIPLE_CTT_LOT_SIZES_IN_OVERLAY;

  const getDownloadSupportedBrowsers = () => window.APP_ENV.DOWNLOAD_SUPPORTED_BROWSERS.split(",");

  return {
    getApiTimeoutMilliSeconds,
    getApiBaseUrl,
    getApiBaseProductUrl,
    getAppBaseUrl,
    getApiEndpointProduct,
    getApiEndpointCostToTrade,
    getApiEndpointSpread,
    getApiEndpointBidAskQuantity,
    getApiEndpointFeedback,
    getApiEndpointHelp,
    getApiEndpointHelpImages,
    areMultipleLotSizesAllowedForOverlayComparison,
    getDownloadSupportedBrowsers
  };
})();

export default service;



// WEBPACK FOOTER //
// ./src/services/managers/env.js